import mapboxgl from "mapbox-gl";
import { useCallback, useEffect, useRef, useState } from "react";

mapboxgl.accessToken =
  process?.env?.NEXT_PUBLIC_MAPBOX_TOKEN ||
  "pk.eyJ1IjoidmFoaWRlYnIiLCJhIjoiY2xzMDAxZWJnMXltbzJqbzY2Z2hiM3dibSJ9.HFtpwJaMyWhazunRWnU4nA";

export const useMapbox = () => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const [mapError, setMapError] = useState<Error | null>(null);

  const initMap = useCallback(
    (options: Omit<mapboxgl.MapboxOptions, "container">) => {
      if (!mapContainer.current) return null;

      try {
        map.current = new mapboxgl.Map({
          container: mapContainer.current,
          style: "mapbox://styles/mapbox/streets-v11",
          attributionControl: false,
          logoPosition: "bottom-left",
          scrollZoom: false,
          boxZoom: false,
          dragRotate: false,
          dragPan: false,
          keyboard: false,
          doubleClickZoom: false,
          touchZoomRotate: false,
          ...options,
        });
        setMapError(null);
      } catch (error) {
        map.current = null;
        setMapError(error instanceof Error ? error : new Error(String(error)));

        return null;
      }

      return map.current;
    },
    []
  );

  return {
    initMap,
    mapContainer,
    map,
    mapError,
  };
};
